import React from 'react'
import { Link } from 'react-router-dom'

function First() {
  return (
    <>
        <section className="team-area fix p-relative pt-120 pb-90" >    
                <div className="container">  
                   <div className="row">                   
                        <div className="col-xl-3">
                            <div className="single-team mb-45" >
                                <div className="team-thumb">
                                    <div className="brd">
                                         <img src="assets/img/team/team01.jpg" alt="img" />
                                    </div>                                   
                                </div>
                                <div className="team-info">
                                    <h4><Link to="/team-details">Bableo Dablo</Link></h4>
                                    <p>Worker</p>
                                    <div className="team-social">
                                        <ul>
                                            <li><Link to="#"><i className="fab fa-facebook-f"></i></Link></li> 
                                            <li> <Link to="#"><i className="fab fa-twitter"></i></Link></li>   
                                            <li><Link to="#"><i className="fab fa-instagram"></i></Link></li>   
                                        </ul>       
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3">
                            <div className="single-team mb-45" >
                                <div className="team-thumb">
                                    <div className="brd">
                                        <img src="assets/img/team/team02.jpg" alt="img" />
                                    </div>
                                </div>
                                <div className="team-info">
                                    <h4><Link to="/team-details">Dawon Crisen</Link></h4>
                                    <p>Worker</p>
                                    <div className="team-social">
                                        <ul>
                                            <li><Link to="#"><i className="fab fa-facebook-f"></i></Link></li> 
                                            <li> <Link to="#"><i className="fab fa-twitter"></i></Link></li>   
                                            <li><Link to="#"><i className="fab fa-instagram"></i></Link></li>   
                                        </ul>       
                                    </div>
                                </div>
                            </div>
                        </div>
                       <div className="col-xl-3">
                            <div className="single-team mb-45" >
                                <div className="team-thumb">
                                    <div className="brd">
                                        <img src="assets/img/team/team03.jpg" alt="img" />
                                    </div>
                                </div>
                                <div className="team-info">
                                    <h4><Link to="/team-details">David Suarez</Link></h4>
                                    <p>Worker</p>
                                    <div className="team-social">
                                        <ul>
                                            <li><Link to="#"><i className="fab fa-facebook-f"></i></Link></li> 
                                            <li> <Link to="#"><i className="fab fa-twitter"></i></Link></li>   
                                            <li><Link to="#"><i className="fab fa-instagram"></i></Link></li>   
                                        </ul>       
                                    </div>
                                </div>
                            </div>
                        </div>
                         <div className="col-xl-3">
                            <div className="single-team mb-45" >
                                <div className="team-thumb">
                                    <div className="brd">
                                         <img src="assets/img/team/team04.jpg" alt="img" />
                                    </div>
                                </div>
                                <div className="team-info">
                                    <h4><Link to="/team-details">Gerard Peano</Link></h4>
                                    <p>Worker</p>
                                    <div className="team-social">
                                        <ul>
                                            <li><Link to="#"><i className="fab fa-facebook-f"></i></Link></li> 
                                            <li> <Link to="#"><i className="fab fa-twitter"></i></Link></li>   
                                            <li><Link to="#"><i className="fab fa-instagram"></i></Link></li>   
                                        </ul>       
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3">
                            <div className="single-team mb-45" >
                                <div className="team-thumb">
                                    <div className="brd">
                                        <img src="assets/img/team/team05.png" alt="img" />
                                    </div>
                                </div>
                                <div className="team-info">
                                    <h4><Link to="/team-details">Ostin Green</Link></h4>
                                   <p>Worker</p>
                                    <div className="team-social">
                                        <ul>
                                            <li><Link to="#"><i className="fab fa-facebook-f"></i></Link></li> 
                                            <li> <Link to="#"><i className="fab fa-twitter"></i></Link></li>   
                                            <li><Link to="#"><i className="fab fa-instagram"></i></Link></li>   
                                        </ul>       
                                    </div>
                                </div>
                            </div>
                        </div>
                       <div className="col-xl-3">
                            <div className="single-team mb-45" >
                                <div className="team-thumb">
                                    <div className="brd">
                                        <img src="assets/img/team/team06.png" alt="img" />
                                    </div>
                                </div>
                                <div className="team-info">
                                    <h4><Link to="/team-details">Norman Colins</Link></h4>
                                    <p>Worker</p>
                                    <div className="team-social">
                                        <ul>
                                            <li><Link to="#"><i className="fab fa-facebook-f"></i></Link></li> 
                                            <li> <Link to="#"><i className="fab fa-twitter"></i></Link></li>   
                                            <li><Link to="#"><i className="fab fa-instagram"></i></Link></li>   
                                        </ul>       
                                    </div>
                                </div>
                            </div>
                        </div>
                         <div className="col-xl-3">
                            <div className="single-team mb-45" >
                                <div className="team-thumb">
                                    <div className="brd">
                                        <img src="assets/img/team/team07.png" alt="img" />
                                    </div>
                                </div>
                                <div className="team-info">
                                    <h4><Link to="/team-details">Ostin Green</Link></h4>
                                   <p>Worker</p>
                                    <div className="team-social">
                                        <ul>
                                            <li><Link to="#"><i className="fab fa-facebook-f"></i></Link></li> 
                                            <li> <Link to="#"><i className="fab fa-twitter"></i></Link></li>   
                                            <li><Link to="#"><i className="fab fa-instagram"></i></Link></li>   
                                        </ul>       
                                    </div>
                                </div>
                            </div>
                        </div>
                       <div className="col-xl-3">
                            <div className="single-team mb-45" >
                                <div className="team-thumb">
                                    <div className="brd">
                                        <img src="assets/img/team/team08.png" alt="img" />
                                    </div>
                                </div>
                                <div className="team-info">
                                    <h4><Link to="/team-details">Norman Colins</Link></h4>
                                    <p>Worker</p>
                                    <div className="team-social">
                                        <ul>
                                            <li><Link to="#"><i className="fab fa-facebook-f"></i></Link></li> 
                                            <li> <Link to="#"><i className="fab fa-twitter"></i></Link></li>   
                                            <li><Link to="#"><i className="fab fa-instagram"></i></Link></li>   
                                        </ul>       
                                    </div>
                                </div>
                            </div>
                        </div>                        
                    </div>
                </div>
        </section>
    </>
  )
}

export default First